import { render, staticRenderFns } from "./YHeader.vue?vue&type=template&id=18f873a4&scoped=true&"
import script from "./YHeader.vue?vue&type=script&lang=js&"
export * from "./YHeader.vue?vue&type=script&lang=js&"
import style0 from "./YHeader.vue?vue&type=style&index=0&id=18f873a4&lang=scss&scoped=true&"
import style1 from "./YHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f873a4",
  null
  
)

export default component.exports